export class Evento {

  public static readonly SUCCESS: number = 200;

  public static readonly CADASTRO_SUCESSO: number = 201;
  public static readonly ATUALIZACAO_SUCESSO: number = 200;
  public static readonly EXCLUSAO_SUCESSO: number = 204;
  public static readonly ERRO: number = 500;

  private _cadastro: boolean;
  private _atualizar: boolean;
  private _deletar: boolean;
  private _evento: boolean;
  private _error: boolean;
  private _unauthorized: boolean;
  private _incorrectPassword: boolean;
  private _validateLogin: boolean;
  private _nenhumSelecionado: boolean;

  constructor() {
    this.limparEventos();
  }

  get evento(): boolean {
    return this._evento;
  }

  set evento(status: boolean) {
    this._evento = status;
  }

  set cadastro(status: boolean) {
    this._cadastro = status;
    this.evento = status;
  }

  get cadastro(): boolean {
    return this._cadastro;
  }

  set atualizar(status: boolean) {
    this._atualizar = status;
    this.evento = status;
  }

  get atualizar(): boolean {
    return this._atualizar;
  }

  set deletar(status: boolean) {
    this._deletar = status;
    this.evento = status;
  }

  get deletar(): boolean {
    return this._deletar;
  }

  set error(status: boolean) {
    this._error = status;
    this.evento = status;
  }

  get error(): boolean {
    return this._error;
  }

  set unauthorized(status: boolean) {
    this._unauthorized = status;
  }

  get unauthorized(): boolean {
    return this._unauthorized;
  }

  set incorrectPassword(status: boolean) {
    this._incorrectPassword = status;
  }

  get incorrectPassword(): boolean {
    return this._incorrectPassword;
  }

  set validateLogin(status: boolean) {
    this._validateLogin = status;
  }

  get validateLogin(): boolean {
    return this._validateLogin;
  }

  set nenhumSelecionado(status: boolean) {
    this._nenhumSelecionado = status;
    this.evento = status;
  }

  get nenhumSelecionado(): boolean {
    return this._nenhumSelecionado;
  }

  limparEventos(): void {
    this._cadastro = false;
    this._atualizar = false;
    this._deletar = false;
    this._evento = false;
    this._error = false;
    this._nenhumSelecionado = false;
    this._unauthorized = false;
    this._incorrectPassword = false;
    this._validateLogin = false;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/eventos/evento.ts